import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleCards() {
  return (
    <section id="articles" className="relative py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-50 text-secondary-700 text-xs font-semibold uppercase tracking-wider mb-4">
            Latest Insights
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            BaseTao Spreadsheet <span className="text-primary-600">Articles &amp; Guides</span>
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            In-depth articles covering everything from getting started to advanced BaseTao Spreadsheet strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((article, idx) => (
            <Link
              key={idx}
              to={article.slug}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-300/50 transition-all duration-300 hover:scale-[1.02] cursor-pointer flex flex-col"
            >
              <div className="relative h-48 md:h-52 overflow-hidden flex-shrink-0">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={`BaseTao Spreadsheet - ${article.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-xs font-medium text-foreground-700">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <span className="text-xs text-foreground-500">{article.date}</span>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mt-1 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-1 mt-3 text-primary-600 text-sm font-medium">
                  Read Article
                  <i className="ri-arrow-right-line text-xs transition-transform group-hover:translate-x-1"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/basetao-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-book-read-line"></i>
            View All Guides
          </Link>
        </div>
      </div>
    </section>
  );
}